@if (order$ | async; as order) {
  <lib-shipping-address-form
    [order]="order"
    (cancel)="onCancel()"
    (update)="onUpdate($event, order)"
  />
}
